<template>
    <div class="container mt-4 mb-4">
        <div class="mb-3">
            <h1>Scans</h1>
        </div>

        <!-- Loader -->
        <div v-if="isLoading">
            <output class="spinner-grow spinner-grow-sm text-primary"></output>
            <span class="ms-2">Loading scans, please wait...</span>
        </div>

        <div v-if="!isLoading">
            <div class="text-end">
                <router-link to="/scans/add/" class="btn btn-primary rounded-pill mb-3 px-4 text-end">+
                    New</router-link>
            </div>

            <div>
                <table class="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>Scan</th>
                            <th>Started at</th>
                            <th>Domains</th>
                            <th>Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="scan in scans" :key="scan.pk">
                            <td>{{ scan.pk }}</td>
                            <td>{{ formatDate(scan.started_at) }}</td>
                            <td>{{ scan.domains.join(', ') }}</td>
                            <td>
                                <span v-if="scan.status === 'to_be_initiated'" class="badge text-bg-primary">To be
                                    initiated</span>
                                <span v-if="scan.status === 'in_progress'" class="badge text-bg-warning">In
                                    progress</span>
                                <span v-if="scan.status === 'completed'" class="badge text-bg-success">Completed</span>
                            </td>
                            <td class="text-center">
                                <a class="btn btn-primary" :href="`/scans/${scan.scan_id}`">
                                    <i class="fa-solid fa-eye"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="d-flex justify-content-between mt-3">
                    <button class="btn btn-primary rounded-circle" @click="getPrevious" :disabled="!previousUrl">
                        <i class="fa-solid fa-arrow-left"></i>
                    </button>

                    <button class="btn btn-primary rounded-circle" @click="getNext" :disabled="!nextUrl">
                        <i class="fa-solid fa-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import api from '../../../api/index.js';
import { formatDate } from '../../../utils/index.js';

export default {
    name: 'ScansView',
    setup() {
        const scans = ref([]);
        const nextUrl = ref(null);
        const previousUrl = ref(null);
        const isLoading = ref(true);  // State to track if data is being loaded

        // Fetch scans from the API when the component is mounted
        const getScans = async (url) => {
            try {
                // Set loading to true before making the request
                isLoading.value = true;

                const response = await api.get(url);

                scans.value = response.data['results'];
                nextUrl.value = response.data['next'];
                previousUrl.value = response.data['previous'];
            } catch (error) {
                console.error('Error fetching scans:', error);
            } finally {
                // Set loading to false once the data has been fetched
                isLoading.value = false;
            }
        };

        // Use the lifecycle hook `onMounted` to fetch data when the component is mounted
        onMounted(() => {
            getScans('/scans/?page=1');
        });

        // Function to fetch the next page
        const getNext = () => {
            if (nextUrl.value) {
                getScans(nextUrl.value);
            }
        };

        // Function to fetch the previous page
        const getPrevious = () => {
            if (previousUrl.value) {
                getScans(previousUrl.value);
            }
        };

        return {
            scans,
            getNext,
            getPrevious,
            nextUrl,
            previousUrl,
            isLoading,
            formatDate
        };
    }
}
</script>
